import { getConfigFor } from '../../../../utils/configService'
import { SPLIT_FEATURES } from '../../../../utils/constants/feature'
import { AnalyticsEvent } from '../../core/AnalyticsEvent'
import { PopupClickedEventSchema } from '../../schemas/popup/PopupClickedEventSchema'
import { CommonEventParams, getCommonParams } from '../../utils/CommonParams'

export interface PopupClickedEventParams extends CommonEventParams {
  BUSINESS_VERTICAL: string
  EVENT_CATEGORY: string
  POPUP_NAME: string
  POPUP_TITLE: string
  POPUP_OPTION: string[]
  POPUP_OPTION_SELECTED: string
}

export class PopupClickedEvent extends AnalyticsEvent {
  constructor(params: PopupClickedEventParams) {
    super(PopupClickedEventSchema, ['segment'])
    this.createEventObject(params)
  }
}

export function trackPopupClickedEvent(params: PopupClickedEventParams) {
  try {
    const { isEnabled = false } =
      getConfigFor(SPLIT_FEATURES.LEAP_CDP_RELEASE_SIX) || {}
    if (isEnabled) {
      const popupClickedEventParams: PopupClickedEventParams = {
        ...getCommonParams(),
        ...params,
      }
      new PopupClickedEvent(popupClickedEventParams).track()
    }
  } catch (error) {
    console.error('Error tracking popup clicked event:', error)
  }
}
